/**
 * @generated SignedSource<<a3353a0a7caf73544d6c68c99ea4b251>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SimplifiedNoteByNotePlayer_Piece$data = {
  readonly id: string;
  readonly file: {
    readonly notes: ReadonlyArray<{
      readonly left_handed: boolean;
      readonly note_start: number;
      readonly bulb_id: string;
      readonly midi_number: number;
    }>;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRenderer_piece" | "PieceRendererStepThru_piece">;
  readonly " $fragmentType": "SimplifiedNoteByNotePlayer_Piece";
};
export type SimplifiedNoteByNotePlayer_Piece$key = {
  readonly " $data"?: SimplifiedNoteByNotePlayer_Piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"SimplifiedNoteByNotePlayer_Piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SimplifiedNoteByNotePlayer_Piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceRenderer_piece"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceRendererStepThru_piece"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicPieceFile",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MusicPieceFileNote",
          "kind": "LinkedField",
          "name": "notes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "left_handed",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "note_start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bulb_id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "midi_number",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "48def6b91d6d7abd996fa4ecec857d2f";

export default node;
